export default{sources:{avif:"__VITE_ASSET__DkvDFDV6__ 273w",webp:"__VITE_ASSET__CK3DST8___ 273w"},img:{src:"__VITE_ASSET__DixQvjnV__",w:273,h:52}};